export default {
  view: 'crm.view_client_person',
  view_managed: 'crm.view_client_person_managed',
  add: 'crm.add_client_person',
  change: 'crm.change_client_person',
  delete: 'crm.delete_client_person',
};
